import { useTranslation } from 'react-i18next';

import ApiEntitySelectDialog from '../../components/ApiEntitySelectDialog/ApiEntitySelectDialog';
import User, { UserRole } from '../../types/User';
import { getGravatar } from '../../utils/gravatar';

interface Props {
    open: boolean;
    onClose: (selectedId?: number) => void;
    type?: UserRole;
    excludedIds?: number[];
}

const UserSelectDialog = (props: Props) => {
    const { open, onClose, type, excludedIds } = props;
    const { t } = useTranslation();

    const map = (user: User) => {
        if (excludedIds && excludedIds.includes(user.id)) {
            return null;
        }
        return {
            id: user.id,
            name: user.surname + ' ' + user.name,
            description: user.email,
            image: getGravatar(user.email)
        };
    };

    const titles = {
        customer: t('dialogs.user_select.select_customer'),
        auditor: t('dialogs.user_select.select_auditor'),
        admin: t('dialogs.user_select.select_admin'),
        certifier: t('dialogs.user_select.select_certifier'),
    };

    const notFoundMessages = {
        customer: t('dialogs.user_select.no_customer_found'),
        auditor: t('dialogs.user_select.no_auditor_found'),
        admin: t('dialogs.user_select.no_admin_found'),
        certifier: t('dialogs.user_select.no_certifier_found'),
    };

    const title = titles[type ?? 'customer'];
    const notFoundMessage = notFoundMessages[type ?? 'customer'];

    return (
        <ApiEntitySelectDialog
            open={open}
            onClose={onClose}
            title={title}
            noEntityFoundMessage={notFoundMessage}
            url='/users'
            params={{ ...(type && { type }) }}
            map={map}
        />
    );
};

export default UserSelectDialog;
